import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseListGroupHeading',
  props: {
    density: {
      default: 'default'
    }
  },
  setup(__props) {
    const props = __props;
    const attrs = computed(() => {
      const result = {};
      // CLASES
      const classes = ['list-group-header list-group-item text-overline pb-2 line-height-100 text-muted px-3'];
      if (props.density == "compact") classes.push("py-2");
      if (props.density == "comfortable") classes.push("py-3");
      result.class = classes.join(' ');
      return result;
    });
    return {
      __sfc: true,
      props,
      attrs
    };
  }
});